const newsHeroSection = $('#hero-section');
const newsHeroNotificationPlacers = newsHeroSection.find('.news-press-card-placer');
const newsHeroNotifications = newsHeroSection.find('.news-press-card');
const heroFinderSearch = newsHeroSection.find('.hero-search-parent');
const heroFinderTagsParent = newsHeroSection.find('.hero-tags-parent');
const heroFinderTags = newsHeroSection.find('.hero-search-tag');
const searchResultsParent = newsHeroSection.find('.search-results');
const searchResultsList = newsHeroSection.find('.search-result-list');
const searchResultsOverflows = newsHeroSection.find('.result-card-overflow');
const searchResults = newsHeroSection.find('.result-card-parent');
const searchInputParent = newsHeroSection.find('.hero-search-parent');
const searchInput = newsHeroSection.find('.hero-search-input');
const searchCloseBtn = newsHeroSection.find('.search-close-btn');
const heroBG = newsHeroSection.find('.hero-blur-bg');

const notificationOffset = isDesktop() ? 2.75 : isTablet() ? 2.604 : 2.778;
const notificationsCount = newsHeroNotifications.length;
const notificationsMax = 3;
let activeNotification = 0; 
let notificationsHovered = false;

let fpInstance;
const searchData = {
  input: '',
  tags: [],
};
const tagsTLs = [];
let isFinderOpened = false;
let isResultOpened = false;

let toggleResultTL, toggleFinderTL, toggleFinderAndResultTL;

const resultLenis = new Lenis({
  wrapper: searchResultsList.get(0),
  autoRaf: true,
});
gsap.set(searchResults, { zIndex: (index) => 1000 - index });
gsap.set(searchResultsParent, { display: 'none' });

const getActiveResults = () => {
  const activeResults = [];
  searchResultsOverflows.each(function () {
    if ($(this).css('display') != 'none') {
      activeResults.push($(this));
    }
  });
  return activeResults;
};

const resultScroller = () => {
  searchResultsOverflows.each(function (index) {
    const resultCard = $(this).find('.result-card-parent');
    if(resultCard.length != 0){
      const resultTop = pxToVw($(this).position().top);
      const k = isDesktop() ? 12 : isTablet() ? 25 : 53;
      let opacity = Math.max(0, 1 - resultTop / k);
      if (resultTop < 0) {
        opacity = 1 - Math.min(5, Math.abs(resultTop)) / 5;
        gsap.set(resultCard, {
          y: `${Math.abs(resultTop)}vw`,
          scale: Math.max(0.3, opacity),
          filter: `blur(${(1 - opacity) * 20}px)`,
        });
      } else {
        gsap.set(resultCard, {
          y: 0,
          scale: 1,
          filter: 'blur(0px)',
        });
      }
      gsap.set($(this), { opacity: opacity });
      
    }
  });
};

resultLenis.on('scroll', (e) => {
  ScrollTrigger.update();
  resultScroller();
});

const toggleResults = (direction) => {
  CustomEase.create('resultsEase', '0.5, 0.0, 0.8, 1.0');
  const resultOffset = isDesktop() ? 5.625 : isTablet() ? 5 : 80;
  const resultDuration = isDesktop() ? 0.42 : isTablet() ? 0.52 : 0.52;
  const toggleResultTL = gsap.timeline({
    paused: true,
    onStart: () => {
      gsap.set(searchResultsParent, { display: 'flex' });
    },
    onReverseComplete: () => {
      gsap.set(searchResultsParent, { display: 'none' });
    },
  });

  toggleResultTL.add(
    gsap.fromTo(
      searchResultsList,
      {
        y: `${resultOffset}vw`,
      },
      {
        y: 0,
        duration: resultDuration,
        ease: 'resultsEase',
      }
    ),
    0
  );
  toggleResultTL.add(
    gsap.fromTo(
      searchResultsList,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: resultDuration - 0.1,
        ease: 'opacityInEasing',
      }
    ),
    0.1
  );

  return toggleResultTL;
};

const toggleFinder = () => {
  const toggleFinderTL = gsap.timeline({
    paused: true,
    onStart: () => {
      headerAnimation(false, 0.4, 0.01).play();
      if (isDesktop()) {
        lenis.scrollTo(0, {
          lock: true,
          onComplete: () => {
            lenis.stop();
          },
        });
      }
    },
    onComplete: () => {
      heroBG.css('pointer-events', 'all');
    },
    onReverseComplete: () => {
      headerAnimation(true, 0.4, 0.01).play();
      heroBG.css('pointer-events', 'none');
      lenis.start();
      clearFinderOnEnd();
    },
  });
  const finderOffset = isDesktop() ? -3.75 : isTablet() ? -5 : 0;
  toggleFinderTL.add(
    gsap.fromTo(
      heroBG,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.67,
        ease: 'pageInEasing',
        overwrite: 'auto',
      }
    ),
    0
  );
  toggleFinderTL.add(
    gsap.fromTo(
      [heroFinderSearch, heroFinderTagsParent],
      {
        y: 0,
      },
      {
        y: `${finderOffset}vw`,
        duration: 0.67,
        ease: 'pageInEasing',
        stagger: {
          each: 0.1,
        },
      }
    ),
    0
  );
  toggleFinderTL.add(
    gsap.fromTo(
      searchCloseBtn,
      {
        y: '2.188vw',
        scale: 0,
      },
      {
        y: 0,
        scale: 1,
        duration: 0.67,
        ease: 'pageInEasing',
        stagger: {
          each: 0.1,
        },
      }
    ),
    0
  );
  return toggleFinderTL;
};

const sortResults = () => {
  let activeCount = 0;
  searchResultsOverflows.each(function () {
    const dataset = this.dataset;
    const datasetValues = Object.values(dataset).map((v) => v.toLowerCase());
    
    const inputValue = searchData.input.toLowerCase();
    const tagValues = searchData.tags.map((tag) => tag.toLowerCase());

    const inputMatch = datasetValues.some((val) => val.includes(inputValue));
    const tagMatch = tagValues.every(tag => dataset.tags?.toLowerCase() == tag);

    if (inputMatch && tagMatch || $(this).hasClass('blank')) {
      activeCount += 1;
      $(this).css('display', 'block');
    } else {
      $(this).css('display', 'none');
    }
  });
  return activeCount;
}

const clearFinderOnStart = () => {
  searchInput.val('');
  searchData.input = '';
  searchData.tags = [];
};

const clearFinderOnEnd = () => {
  count = sortResults();
  resultLenis.scrollTo(0);
};

const addNewsHeroAnimation = () => {
  const animationConfig = {
    offsetPercent: '150',
    opacityStart: 0.9,
    blurStart: '5px',
    duration: 0.9,
    delay: 0,
    stagger: 0.15,
    isDurationCommon: false,
  }

  const heroDescription = newsHeroSection.find('.hero-description');
  const heroTitle = newsHeroSection.find('.hero-title');
  const heroDescriptorCard = newsHeroSection.find('.descriptor-card');
  const heroBtn = newsHeroSection.find('.button-parent');

  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
      gsap.delayedCall(2.5, startNotificationsLoop);
      newsHeroNotifications.on('mouseenter', () => notificationsHovered = true);
      newsHeroNotifications.on('mouseleave', () => notificationsHovered = false);
    },
  });

  heroTL.add(addTitleAnimation({element: heroTitle, animationConfig: animationConfig}).play(), 0.5);
  heroTL.add(elementInAnimationYWOpacity(heroDescription, '1000%', 0, 1, 0.9, 0.9, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 0.5);
  heroTL.add(addDescriptorCardAnimation(heroDescriptorCard, '100%', 0.667, 0).play(), 0.9);
  heroTL.add(elementInAnimationYWOpacity(heroFinderSearch, '8.75vw', 0, 1, 1, 0.8, 0.2).play(), 0.7);
  heroTL.add(elementInAnimationYWOpacity(heroFinderTagsParent, '8.75vw', 0, 1, 1, 0.8, 0.2).play(), 0.8);
  heroTL.add(elementInAnimationYWOpacity(heroFinderTagsParent, '8.75vw', 0, 1, 1, 0.8, 0.2).play(), 0.8);
  heroTL.add(addBtnAnimation(heroBtn).play(), 1.5);
  heroTL.add(elementInAnimationYWOpacity(newsHeroNotificationPlacers, '-=30%', 0, 1, 1.3, 1.3, 0, 0.1, 'start', 'pageInEasing', 'pageInEasing').play(), 1.5);


  heroTL.add(() => {
    if (!isFinderOpened) {
      headerAnimation(true, 0.6, 0.01).play();
    }
  }, 1.9);

  return heroTL;
};

const setNotifications = () => {
    const notificationToppers = newsHeroNotifications.find('.news-press-card-topper');
    let maxNotificationTopperHeight = 0;
    notificationToppers.each(function(){
        const notificationTopperHeight = pxToVw($(this).height());
        if( notificationTopperHeight > maxNotificationTopperHeight){
            maxNotificationTopperHeight = notificationTopperHeight;
        }
    })
    gsap.set(notificationToppers, {height: `${maxNotificationTopperHeight}vw`});
    
    gsap.set(newsHeroNotificationPlacers, {
        bottom: (index) => `${index * notificationOffset}vw`,
        zIndex: (index) => 200 - ((notificationsCount - activeNotification + index) % notificationsCount),
        display: (index) => index < notificationsMax ? 'block' : 'none',
    });
    gsap.set(newsHeroNotifications, {
      opacity: (index) => 1 - ((notificationsCount - activeNotification + index) % notificationsCount) * 0.33,
    });
};
setNotifications();

const changeNotificationsAnimation = (duration) => {
  gsap.fromTo(newsHeroNotificationPlacers, {
    bottom: (index) => `${((notificationsCount - activeNotification + index) % notificationsCount) * notificationOffset}vw`,
    zIndex: (index) => `${200 - ((notificationsCount - activeNotification + index) % notificationsCount)}`,
  }, {
    bottom: (index) => `${(((notificationsCount - activeNotification + index) % notificationsCount) - 1) * notificationOffset}vw`,
    zIndex: (index) => `${201 - ((notificationsCount - activeNotification + index) % notificationsCount)}`,
    duration: duration,
    ease: 'pageInEasing',
    delay: (index) => ((notificationsCount - activeNotification + index) % notificationsCount) * 0.063,
    onComplete: () => {
      activeNotification = (activeNotification + 1) % notificationsCount;
    }
  })
  gsap.fromTo(newsHeroNotifications, {
    opacity: (index) => 1 - ((notificationsCount - activeNotification + index) % notificationsCount) * 0.33,
  }, {
    opacity: (index) => 1 - (((notificationsCount - activeNotification + index) % notificationsCount) - 1) * 0.33,
    duration: duration,
    ease: 'pageInEasing',
    delay: (index) => ((notificationsCount - activeNotification + index) % notificationsCount) * 0.063,
  })
  gsap.set(newsHeroNotificationPlacers.eq(activeNotification), { display: 'none', delay: duration * 0.5 + 0.0315 * (notificationsCount - 1) });
  gsap.set(newsHeroNotificationPlacers.eq((activeNotification + notificationsMax) % notificationsCount), { display: 'block', delay: duration * 0.5 + 0.0315 * (notificationsCount - 1) });
};

const startNotificationsLoop = () => {
  if(!notificationsHovered){
    changeNotificationsAnimation(0.8);
  }
  gsap.delayedCall(4, startNotificationsLoop);
};

const initNewsHero = () => {
  toggleResultTL = toggleResults();
  toggleFinderTL = toggleFinder();

  $(window).on('deviceChange', function () {
    if (toggleResultTL) toggleResultTL.kill();
    if (toggleFinderTL) toggleFinderTL.kill();
    toggleResultTL = toggleResults();
    toggleFinderTL = toggleFinder();
  });

  heroBG.on('click', () => {
    let delay = 0;
  });

  searchInput.on('focus', () => {
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    requestAnimationFrame(() => {
      window.scrollTo(scrollX, scrollY);
    });

    gsap.to(searchInputParent, { borderColor: 'rgba(255, 255, 255, 0.20)', duration: 0.67, ease: 'pageInEasing' });
    if (!isResultOpened) {
      if (!isFinderOpened) {
        toggleFinderTL.play();
        gsap.delayedCall(0.2, () => toggleResultTL.play());
        isFinderOpened = !isFinderOpened;
      } else if (!isResultOpened) {
        let delay;
        if (lastActiveTag != undefined) {
          tagsTLs[lastActiveTag].reverse();
          delay = tagsTLs[lastActiveTag].duration() / 2;
          lastActiveTag = undefined;
        }
        gsap.delayedCall(delay, () => toggleResultTL.play());
      }
      isResultOpened = !isResultOpened;
    }
  });

  searchInput.on('blur', () => {
    gsap.to(searchInputParent, { borderColor: 'transparent', duration: 0.67, ease: 'pageInEasing' });
  });

  searchCloseBtn.on('click', () => {
    let delay = 0;
    if (isFinderOpened) {
      clearFinderOnStart();
      if (isResultOpened) {
        gsap.delayedCall(0.1, () => toggleResultTL.reverse());
        delay = 0; //toggleResultTL.duration() / 3;
        isResultOpened = !isResultOpened;
      } else if (lastActiveTag != undefined) {
        tagsTLs[lastActiveTag].reverse();
        delay = 0.2; //tagsTLs[lastActiveTag].duration() / 2;
        lastActiveTag = undefined;
      }
      gsap.delayedCall(delay, () => toggleFinderTL.reverse());
      isFinderOpened = !isFinderOpened;
    }
  });

  if (isDesktop()) {
    searchCloseBtn.on('mouseenter', function () {
      gsap.to($(this), {
        rotate: '180deg',
        duration: 0.667,
        ease: 'pageInEasing',
        overwrite: 'auto',
      });
    });

    searchCloseBtn.on('mouseleave', function () {
      gsap.to($(this), {
        rotate: '0',
        duration: 0.667,
        ease: 'pageInEasing',
        overwrite: 'auto',
      });
    });
  }

  /* Input controls */
  searchInput.on('input', function () {
    searchData.input = $(this).val();
    sortResults(false);
    resultScroller();
  });

  searchResults.each(function () {
    const resultIcon = $(this).find('.result-card-icon');
    $(this).on('mouseenter', () => {
      arrowAnimation(resultIcon, 1, 1);
    });
    $(this).on('mouseleave', () => {
      arrowAnimation(resultIcon, 1, 0);
    });
  });

  heroFinderTags.on('click', function(){
    const tagValue = $(this).text();
    if(!$(this).hasClass('active')){
      searchData.tags.push(tagValue);
    } else {
      searchData.tags = searchData.tags.filter((tag) => tag !== tagValue);
    }
    $(this).toggleClass('active');
    const count = sortResults();
    resultScroller();
  })
};

$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  initNewsHero();
  const newsHeroTL = addNewsHeroAnimation();
  pageIn(newsHeroTL, nav);
  openPopupFromURL();
});
